// Positive money with up to 2 decimal places (e.g. "0", "1500", "1500.25").
export const MONEY_INPUT_REGEX = /^\d+(\.\d{1,2})?$/;

// Signed money with up to 2 decimal places (e.g. "-1500.25", "0", "1500").
// Derived from MONEY_INPUT_REGEX (an optional leading "-" prefixed onto the
// same digits-and-decimal pattern) so the two can never drift apart: any
// future change to what counts as a valid unsigned amount is picked up here
// automatically.
export const SIGNED_MONEY_INPUT_REGEX = new RegExp(`^-?${MONEY_INPUT_REGEX.source.slice(1)}`);
